module.exports = __webpack_public_path__ + "img/extended.28476296.png";